import { isAdministrativeProfile } from '@/utils/profile';

/**
 * Quem enxerga a Clara.
 *
 * Ela e ferramenta da operacao interna: le carteira de clientes, operacoes e
 * limites do tenant inteiro. Nos perfis Corban e Cliente esse alcance nao faz
 * sentido, entao ela nao aparece — e, onde da, nem chega a ser montada.
 *
 * A regra mora aqui e nao numa diretiva porque `v-administrative-access` esconde
 * o elemento em que e declarada, e tanto o lancador do topo quanto os gatilhos
 * de tabela sao ativadores de `v-tooltip`. O Vuetify renderiza o ativador no PAI
 * do tooltip e deixa a raiz do componente como um <span> vazio ao lado: a
 * diretiva escondia o span e o botao continuava na tela.
 */
export function claraDisponivelPara(user) {
  return isAdministrativeProfile(user);
}

export default { claraDisponivelPara };
